const DEFAULT_ALLOCATIONS = {
  Agressiva: {
    pandhoraEssencial: 0,
    pandhoraLb: 0,
    rendaFixa: 20,
    ipca: 15,
    multimercado: 20,
    rendaVariavel: 40,
    rendaVariavelGlobal: 5,
    dolar: 0,
  },
  Moderada: {
    pandhoraEssencial: 0,
    pandhoraLb: 0,
    rendaFixa: 15,
    ipca: 20,
    multimercado: 40,
    rendaVariavel: 20,
    rendaVariavelGlobal: 5,
    dolar: 0,
  },
  Conservadora: {
    pandhoraEssencial: 0,
    pandhoraLb: 0,
    rendaFixa: 80,
    ipca: 0,
    multimercado: 20,
    rendaVariavel: 0,
    rendaVariavelGlobal: 0,
    dolar: 0,
  },
};

export default DEFAULT_ALLOCATIONS;
